import { combineReducers } from 'redux';

import filtersReducer from './filters';
import coverageReducers from './coverage/reducers';
import testHistoryReducers from './test-history/reducers';
import testOverviewReducers from './test-overview/reducers';
import testErrorReducers from './test-error/reducers';
import trendsReducer from './trends/reducers';

const reducers = {
  testError: testErrorReducers,
  filters: filtersReducer,
  coverage: coverageReducers,
  testHistory: testHistoryReducers,
  testOverview: testOverviewReducers,
  trends: trendsReducer,
};

export default combineReducers(reducers);
